export default __webpack_public_path__ + "static/media/header-d.91f64f63.png";